import React from 'react';
import PropTypes from 'prop-types';

import { Form } from 'react-bootstrap';

import SearchBar from 'components/shared/SearchBar';

function NameSearchFilter({ value, onChange, placeholder, disabled }) {
  return (
    <Form.Group className="mb-0">
      <Form.Label>Search Manufacturer</Form.Label>
      <SearchBar value={value} setValue={onChange} placeholder={placeholder} disabled={disabled} />
    </Form.Group>
  );
}

NameSearchFilter.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
};

NameSearchFilter.defaultProps = {
  value: '',
  placeholder: 'Search by manufacturer name...',
  disabled: false,
};

export default NameSearchFilter;
